import React from "react";
import SunriseIcon from "../../assets/Sunrise.png";
import SunsetIcon from "../../assets/Sunset.png";
import { splitMeridiem } from "../../utils/time";

const SunriseSunsetCard = ({ colorSettings = {}, prayerData }) => {
  const {
    // bodyBackgroundColor = "#096D6D",
    bodyTextColor = "#ffffff",
  } = colorSettings;

  const sunrise = prayerData?.startTimes?.timings?.sunrise || "N/A";
  const sunset = prayerData?.startTimes?.timings?.sunset || "N/A";

  const displayData = [
    { label: "SUNRISE", time: sunrise, icon: SunriseIcon },
    { label: "SUNSET", time: sunset, icon: SunsetIcon },
  ];

  return (
    <div
      className="flex flex-wrap -mx-2"
      style={{ color: bodyTextColor }}
    >
      {displayData.map(({ label, time, icon }, i) => {
        const parts = splitMeridiem(time);
        return (
          <div key={i} className="w-1/2 flex justify-center pt-[1svh]">
            <div className="flex flex-col justify-center items-center">
              <img
                src={icon}
                alt={label}
                className="w-[7svh] mb-0"
              />
              <p className="text-[3.1svh]">
                {parts ? (
                  <>
                    <span>{parts.main}</span>
                    <span className="text-[2.2svh] ml-[0.2svh]">
                      {parts.mer}
                    </span>
                  </>
                ) : (
                  (time || "—").replace(/^0(\d):/, "$1:")
                )}
              </p>
              <h4 className="text-[2svh] my-[0.7svh] font-medium">{label}</h4>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SunriseSunsetCard;